import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getMenuItem, getMenuItemStatus, getMenuError } from '@store/reducers/menu/selectors';
import { getMenuItem as getMenuItemAction, editMenuItem } from '@store/actions/menu';
import { getPermittedPermissions } from '@store/reducers/check-permission/selectors';
import Main from './Main';

const mapStateToProps = state => ({
  menuItem: getMenuItem(state),
  status: getMenuItemStatus(state),
  errors: getMenuError(state),
  permittedPermissions: getPermittedPermissions(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getMenuItem: getMenuItemAction,
      editMenuItem,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
